import { render, staticRenderFns } from "./TicketCreate.vue?vue&type=template&id=6be7c2d0&"
import script from "./TicketCreate.vue?vue&type=script&lang=js&"
export * from "./TicketCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports